import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Booking = () => {
  useEffect(() => {
    // Vi fjerner eventuelle gamle instanser af scriptet for at sikre en frisk indlæsning
    const existingScript = document.querySelector('script[src="https://asset-tidycal.b-cdn.net/js/embed.js"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Vi opretter scriptet på ny
    const script = document.createElement('script');
    script.src = "https://asset-tidycal.b-cdn.net/js/embed.js";
    script.async = true;
    
    // Vi tilføjer det til dokumentet
    document.body.appendChild(script);

    return () => {
      // Oprydning når brugeren forlader sektionen (valgfrit, men god praksis)
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="booking" className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl font-black text-slate-900 tracking-tight sm:text-5xl mb-6"
          >
            Book et kaffemøde
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-xl text-slate-600 font-light italic"
          >
            Vælg et tidspunkt i min kalender, der passer dig bedst. Jeg glæder mig til en uforpligtende snak.
          </motion.p>
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-[3rem] shadow-2xl border border-stone-100 overflow-hidden min-h-[700px] flex items-center justify-center"
        >
          {/* TidyCal Embed - Præcis som du bad om */}
          <div 
            className="tidycal-embed w-full" 
            data-path="team/per/en-times-kaffemode-med-per"
          >
            {/* Fallback tekst mens kalenderen loader */}
            <div className="text-center py-20 text-slate-400 font-medium">
              Indlæser kalender...
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Booking;